import {
  Directive,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, debounceTime, filter, takeUntil } from 'rxjs';
import { CPFValidation, CPF_SIZE } from '../constants/cpf-validator.constants';

@Directive({
  selector: '[cpfValidator]',
})
export class CpfValidatorDirective implements OnInit, OnDestroy {
  formControlRef: InputSignal<FormControl> = input<FormControl>();

  destroySubject: Subject<boolean> = new Subject();

  constructor() {}

  ngOnDestroy(): void {
    this.destroySubject.next(true);
    this.destroySubject.complete();
  }

  ngOnInit(): void {
    this.formControlRef()
      .valueChanges.pipe(
        filter((value: string) => value?.length === CPF_SIZE),
        debounceTime(100),
        takeUntil(this.destroySubject)
      )
      .subscribe((value) => {
        const isValid = CPFValidation(value);

        if (isValid) {
          this.formControlRef().setErrors(null, { emitEvent: false });
        } else {
          this.formControlRef().setErrors(
            {
              invalidCpf: true,
            },
            { emitEvent: false }
          );
        }
      });
  }
}
